export default function WhyChooseUs() {
  const advantages = [
    { icon: 'ri-calendar-check-line', value: '18+', label: 'лет практики' },
    { icon: 'ri-building-2-line', value: '100+', label: 'корпоративных проектов' },
    { icon: 'ri-presentation-line', value: '450+', label: 'тренингов' },
    { icon: 'ri-user-star-line', value: '4500+', label: 'участников' },
  ];

  const reasons = [
    { icon: 'ri-user-voice-line', title: 'Практикующий бизнес-тренер', desc: 'Не теоретик — продолжаю лично работать с клиентами, консультировать бизнес и сопровождать сложные сделки. Поэтому обучаю тому, что реально работает.' },
    { icon: 'ri-file-copy-2-line', title: 'Авторские программы', desc: 'Каждая программа создаётся под конкретную компанию после диагностики. Никаких шаблонных решений — только то, что нужно вашему бизнесу.' },
    { icon: 'ri-search-eye-line', title: 'Диагностика перед обучением', desc: 'Перед тренингом изучаем бизнес-процессы, анализируем звонки и переписки, проводим интервью с руководителями. Без диагностики эффективного обучения не бывает.' },
    { icon: 'ri-rocket-2-line', title: 'Сопровождение внедрения', desc: 'Не просто провожу тренинг и уезжаю. Сопровождаю команду от 1 до 6 месяцев: разбор кейсов, домашние задания, обратная связь, корректировка инструментов.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему компании обращаются именно к нам
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системный подход, реальный опыт и измеримые результаты. Вот что отличает нашу работу.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12 max-w-4xl mx-auto">
          {advantages.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 text-center border border-gray-100 hover:shadow-md transition-all group">
              <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                <i className={`${item.icon} text-teal-600 text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-1">{item.value}</div>
              <div className="text-xs text-gray-500 leading-tight">{item.label}</div>
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-5 max-w-5xl mx-auto">
          {reasons.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 md:p-7 border border-gray-100 hover:border-teal-100 transition-colors group">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors duration-300">
                  <i className={`${item.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}